import { createContext } from 'react'
import { useValues } from './CartProvider'

export const CartContext = createContext({} as ReturnType<typeof useValues>)
